import {
    ADD_ACTIVITY_TYPE, ADD_CERTIFICATE_LIST
} from '../../Actions/FormDataActions/AddCMFormData';

const initialState = {
    activityType: "",
    certificateNumber: "",
    certificateNumberValue: "",
    certificatesList :[]
};

export default function formReducer(state = initialState, action) {

    switch (action.type) {
        case ADD_ACTIVITY_TYPE: {
            if (action.payload.activityType === 'noChangeRenewal') {
                return {
                    ...state,
                    activityType: action.payload.activityType,
                    certificateNumber: action.payload.certificateNumber,
                    certificateNumberValue: action.payload.certificateNumberValue
                };
            }

            return {
                ...state,
                notificationType: action.payload,
            };
        }

        case ADD_CERTIFICATE_LIST : {
            if (action.payload.certificateList.length){
                return  {
                    ...state,
                    certificatesList: action.payload.certificateList
                }
            }

            return {
                notificationType: action.payload,
            };
        }

        default:
            return state;
    }
}
